module.exports = __webpack_public_path__ + "assets/ic-bitcoinist.294a8e71.svg";